module.exports = __webpack_public_path__ + "img/teacher_manage.a33c23f2.png";